// extracted by mini-css-extract-plugin
module.exports = {"page__photo":"page-template-module--page__photo--5gAX_"};